import styled from "@emotion/styled";

export const ClearSubmitFormButtonContainer = styled.div`
    padding-top: 1.25rem;
`;

export const ClearSubmitFormButtonContentContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: center;
`;
